"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.getInitialValue = void 0;
var getInitialValue = exports.getInitialValue = function getInitialValue(settings) {
  return null;
};
var validate = exports.validate = function validate(value, settings) {
  var error;
  if (!value && settings.isRequired) {
    return settings.requiredErrorMessage;
  }
  if (value && value.size > settings.maxFileSize * 1024 * 1024) {
    return "File cannot be larger than ".concat(settings.maxFileSize, " Mb");
  }
  return error;
};